import { render, staticRenderFns } from "./mainParent.vue?vue&type=template&id=cd152d6a&scoped=true&"
import script from "./mainParent.vue?vue&type=script&lang=js&"
export * from "./mainParent.vue?vue&type=script&lang=js&"
import style0 from "./mainParent.vue?vue&type=style&index=0&id=cd152d6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd152d6a",
  null
  
)

export default component.exports